import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';

export const ListHeader = memo(({ title, description, actions }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.container}>
      <View style={styles.textsContainer}>
        <Text style={styles.text}>{title}</Text>
        <Text style={styles.description}>{description}</Text>
      </View>
      <Space size={16} />
      {actions && (
        <View style={styles.actionsContainer}>
          <ListHeaderActions {...{ actions }} />
        </View>
      )}
    </View>
  );
});

const ListHeaderActions = memo(({ actions }) => {
  const { styles } = useStyle();
  return actions
    .map((item, index) => <Button style={styles.actionContainer} {...item} />)
    .reduce((prev, current) => [prev, <Space size={8} />, current]);
});

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textsContainer: {},
  text: {
    fontSize: 14,
    color: colors.gray23,
  },
  description: {
    fontSize: 12,
    color: colors.gray21,
  },
  actionContainer: {},
  actionsContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));
